module.exports = __webpack_public_path__ + "media/images/athletes/3565-bbc856888e6a1fa166c9834ebd2dcf1a.png";